import {Calendar} from "@fullcalendar/core";
import Quill from "quill";

interface FullCalendarImport {
    Calendar: typeof Calendar,
    DayGrid: any,
    TimeGrid: any,
    List: any,
    Interaction: any
}

export default class FullCalendarLoader {

    /**
     * 0 - not loaded
     * 1 - loading
     * 2 - loaded
     * @private
     */
    private static status = 0;

    private static promise: Promise<FullCalendarImport>;

    private static instance: FullCalendarImport;

    public static load(): Promise<FullCalendarImport> {
        if (FullCalendarLoader.status == 0) {
            FullCalendarLoader.status = 1;

            FullCalendarLoader.promise = Promise.all([

                import(/* webpackMode: "lazy-once", webpackChunkName: "fullcalendar-kit" */ '@fullcalendar/core'),
                import(/* webpackMode: "lazy-once", webpackChunkName: "fullcalendar-kit" */ '@fullcalendar/daygrid'),
                import(/* webpackMode: "lazy-once", webpackChunkName: "fullcalendar-kit" */ '@fullcalendar/timegrid'),
                import(/* webpackMode: "lazy-once", webpackChunkName: "fullcalendar-kit" */ '@fullcalendar/list'),
                import(/* webpackMode: "lazy-once", webpackChunkName: "fullcalendar-kit" */ '@fullcalendar/interaction'),

                import(/* webpackChunkName: "fullcalendar-css" */ '../style/full-calendar.css'),

            ]).then(v => {
                console.log("FullCalendar Loader", v[0]);


                const Q = (v[0] as any).Calendar;

                console.log("FullCalendar Loader", Q);

                let core = Q;
                let daygrid = v[1].default;
                let timegrid = v[2].default;
                let list = v[3].default;
                let interaction = v[4].default;

                let exp = {
                    Calendar: core,
                    DayGrid: daygrid,
                    TimeGrid: timegrid,
                    List: list,
                    Interaction: interaction
                } as unknown as FullCalendarImport;

                FullCalendarLoader.instance = exp;
                FullCalendarLoader.status = 2;

                return exp;

            });


            return FullCalendarLoader.promise;
        } else if (FullCalendarLoader.status == 1) {
            return FullCalendarLoader.promise;
        } else {
            return Promise.resolve(FullCalendarLoader.instance);
        }
    }

}